import {UserSummary} from '../../../../../account/modules/user/api/entity/userSummary.model';
import {EntityLinkedToAccountWithAuditMetadata} from '../../../../../common/entity/entityLinkedToAccountWithAuditMetadata';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {OfficeSummaryModel} from '../../../../../office/api/model/officeSummary.model';
import {AgendaCalendarSummaryModel} from "./agendaCalendarSummary.model";


export class AgendaCalendarModel extends EntityLinkedToAccountWithAuditMetadata{
    summary: AgendaCalendarSummaryModel;
    owner: UserSummary;
    office: OfficeSummaryModel;
    visible: boolean;
    type: LovValueSummary;
    importExternalId: string;
    exportExternalId: string;
    active: boolean;
    onlineBooking: boolean;
    externalId: string;
}

export enum AgendaCalendarType {
    AGENDA_CALENDAR_TYPE_PODOPRO = 'AGENDA_CALENDAR_TYPE_PODOPRO',
    AGENDA_CALENDAR_TYPE_GOOGLE = 'AGENDA_CALENDAR_TYPE_GOOGLE',
}

export enum AgendaCalendarLovList {
    AGENDA_CALENDAR_TYPE = 'AGENDA_CALENDAR_TYPE'
}
